import { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";

const AdminAuthCtx = createContext({ admin: null, ready: false, login: () => {}, verify: () => {}, logout: () => {} });

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(() => {
    try { return JSON.parse(localStorage.getItem("empco_admin_user") || "null"); }
    catch { return null; }
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const tok = localStorage.getItem("empco_admin_token");
    if (!tok) { setReady(true); return; }
    adminApi.get("/auth/me")
      .then((r) => { setAdmin(r.data); localStorage.setItem("empco_admin_user", JSON.stringify(r.data)); })
      .catch(() => { localStorage.removeItem("empco_admin_token"); localStorage.removeItem("empco_admin_user"); setAdmin(null); })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    return data; // { challenge_id, email_sent, expires_in }
  };

  const verify = async (challenge_id, otp) => {
    const { data } = await adminApi.post("/auth/verify-otp", { challenge_id, otp });
    localStorage.setItem("empco_admin_token", data.token);
    localStorage.setItem("empco_admin_user", JSON.stringify(data.user));
    setAdmin(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await adminApi.post("/auth/logout"); } catch {}
    localStorage.removeItem("empco_admin_token");
    localStorage.removeItem("empco_admin_user");
    setAdmin(null);
  };

  return <AdminAuthCtx.Provider value={{ admin, ready, login, verify, logout }}>{children}</AdminAuthCtx.Provider>;
}

export const useAdminAuth = () => useContext(AdminAuthCtx);
